/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { meV4Schema } from './meV4Schema'
import { roleTypeAdvancedNameSchema } from './roleTypeAdvancedNameSchema'

export const acceptInviteResponseV4Schema = z
  .object({
    accessToken: z
      .string()
      .min(1)
      .default('')
      .describe("The JWT access token for the new account, already in the joined org's context."),
    expiresOn: z.iso
      .datetime({ offset: true, local: true })
      .default('')
      .describe('UTC moment the access token expires.'),
    roleGranted: roleTypeAdvancedNameSchema.describe(
      'The role actually granted — reduced, possibly to `None`, when the org had no free seat.'
    ),
    user: meV4Schema.describe(
      'Shape returned by `GET /api/v4/me/getMe` — the app-shell identity plus the topbar counts.'
    ),
  })
  .describe('Result of redeeming an invitation: the account was created and logged straight in.')
